import styles from './Suggestion.module.scss'
import { Button } from '../components/Button'
export const Suggestion: React.FC = () => {
  return (
    <div className={styles.suggestion_container}>
      <div className={styles.main_container}>
        <div className={styles.title_container}>
          <p className={styles.title}>ご予算感に合わせた無理のないご提案が可能です</p>
          <div className={styles.text_container}>
            <p className={styles.text}>
              AWSセレクトティアサービスパートナーに認定されているAitriaにお気軽にお問い合わせください。
            </p>
            <p className={styles.text}>導入時期や予算が未定でも、担当者が丁寧にご対応いたします。</p>
          </div>
        </div>
        <div className={styles.button_container}>
          {/* <Button text="サービス資料をダウンロード" href="資料追加" /> */}
          <Button text="お問い合わせ" href="/contact/" red="true" />
        </div>
      </div>
    </div>
  )
}
